// add here more fields when required
const leadFieldsToUpdate = ['reasonForSale', 'baseCurrentRentEuro'];

export function prepareLeadUpdateData(rawFormData: Record<string, unknown>) {
  return Object.fromEntries(leadFieldsToUpdate.map((k) => [k, rawFormData[k]]));
}
